import {attr, controller, target} from '@github/catalyst'
import type {AutoCheckElement} from '@github/auto-check-element'
import {verifiedFetchJSON} from '@github-ui/verified-fetch'

@controller
export class SignupFormElement extends HTMLElement {
  @attr declare url: string
  @attr declare redirect: string
  @attr declare username: string
  @target declare span: HTMLElement
  @target declare textfield: HTMLInputElement
  @target declare anchor: HTMLAnchorElement

  interact() {
    if (this.textfield && this.username) {
      this.textfield.value = this.username
      this.textfield.focus()

      this.textfield.addEventListener(
        'blur',
        () => {
          const autoCheck = this.textfield.closest<AutoCheckElement>('auto-check')
          if (autoCheck) {
            autoCheck.triggerValidation()
          }
        },
        {once: true},
      )
    }
  }

  async connectedCallback() {
    if (!this.span) return

    const socialSignupInfo = await this.#fetchSocialSignupInfo()

    if (!socialSignupInfo || !socialSignupInfo.email || !socialSignupInfo.suggested_username) {
      window.location.replace(this.redirect)
    } else {
      this.span.textContent = socialSignupInfo.email
      this.anchor.textContent = socialSignupInfo.suggested_username
      this.username = socialSignupInfo.suggested_username
    }

    const autoCheck = this.textfield.closest<AutoCheckElement>('auto-check')
    const usernameSuggestionHelper = document.getElementById('social-username-suggestion-helper-text')

    if (autoCheck && usernameSuggestionHelper) {
      autoCheck.addEventListener('auto-check-error', () => {
        usernameSuggestionHelper.hidden = true
      })
      autoCheck.addEventListener('auto-check-success', () => {
        usernameSuggestionHelper.hidden = false
      })
    }

    if (this.textfield && usernameSuggestionHelper) {
      this.textfield.addEventListener('input', () => {
        if (this.textfield.value === '') {
          usernameSuggestionHelper.hidden = false
        }
      })
    }
  }

  async #fetchSocialSignupInfo() {
    if (!this.url) {
      window.location.replace(this.redirect)
    }

    try {
      const response = await verifiedFetchJSON(this.url, {
        method: 'POST',
        headers: {
          Accept: 'application/json',
        },
      })
      if (!response.ok) {
        window.location.replace(this.redirect)
      }
      const data = await response.json()
      return data
    } catch {
      window.location.replace(this.redirect)
    }
  }
}
